import { userServerAddress } from "../../common/MetaSetting";
import { authGet, authPost, authPut } from "../../utils/authFetch";
import { fetchHttpResponseHandler } from "../../util/UtilFunction";

const apiService = {
  get: async (url: string): Promise<any> => {
    const response = await authGet(url);
    const processedResponse = await fetchHttpResponseHandler(response);
    if (processedResponse.responseType !== 1) throw new Error(`Network response was not ok: ${processedResponse.message}`);
    return processedResponse.content;
  },
  post: async (url: string, requestData: any): Promise<any> => {
    const response = await authPost(url, {
      body: JSON.stringify(requestData)
    });
    const processedResponse = await fetchHttpResponseHandler(response);
    if (processedResponse.responseType !== 1) throw new Error(`Network response was not ok: ${processedResponse.message}`);
    return processedResponse.content;
  },
  put: async (url: string, requestData: any): Promise<any> => {
    const response = await authPut(url, {
      body: JSON.stringify(requestData)
    });
    const processedResponse = await fetchHttpResponseHandler(response);
    if (processedResponse.responseType !== 1) throw new Error(`Network response was not ok: ${processedResponse.message}`);
    return processedResponse.content;
  }
};

/**
 * 根据关键字搜索用户
 */
export const fetchUsersByKey = async (key: string): Promise<any> => {
  const response = await apiService.get(`${userServerAddress}/user/search?key=${key}`);
  
  // 返回fetchHttpResponseHandler格式的响应
  return {
    responseType: 1, // HttpResponseType.SUCCESS
    message: '',
    content: response.data // 直接使用response.data，因为API返回的数据在data字段中
  };
};

/**
 * 根据用户名列表获取用户标记
 */
export const fetchUserMarksByUsernames = async (usernames: string[]): Promise<any> => {
  const response = await apiService.post(`${userServerAddress}/user/marks`, { usernames });
  return response.data || response;
};

/**
 * 根据userId列表获取用户标记
 */
export const fetchUserMarksByIds = async (userIds: number[]): Promise<any> => {
  const response = await apiService.post(`${userServerAddress}/user/marks-by-ids`, { userIds });
  return response.data || response;
};

/**
 * 获取当前用户详情
 */
export const fetchUser = async (): Promise<any> => {
  const response = await apiService.get(`${userServerAddress}/user/detail`);
  return response.data || response;
};

// Query keys
export const userKeys = {
  all: ['users'] as const,
  lists: () => [...userKeys.all, 'list'] as const,
  list: () => [...userKeys.lists()] as const,
  details: () => [...userKeys.all, 'detail'] as const,
  detail: (id: string) => [...userKeys.details(), id] as const,
  search: (key: string) => [...userKeys.all, 'search', key] as const,
  marks: () => [...userKeys.all, 'marks'] as const,
};

